/**
 * Thresholds for displaying toolbox buttons.
 */
export const THRESHOLDS = [
    {
        width: 1360,
        order: ['microphone', 'camera', 'desktop', 'closedcaptions', 'raisehand']
    },
    {
        width: 1040,
        order: ['microphone', 'camera', 'desktop', 'raisehand']
    },
    {
        width: 940,
        order: ['microphone', 'camera', 'desktop', 'raisehand']
    },
    {
        width: 840,
        order: ['microphone', 'camera', 'desktop']
    },
    {
        width: 740,
        order: ['microphone', 'camera']
    },
    {
        width: 450,
        order: ['microphone', 'camera']
    },
    {
        width: 400,
        order: ['microphone', 'camera']
    }
];
/**
 * Thresholds for displaying toolbox buttons right.
 */
export const THRESHOLDS_SUB = [
    {
        width: 1360,
        order: ['security', 'participants-pane', 'chat']
    },
    {
        width: 1040,
        order: ['security', 'participants-pane', 'chat']
    },
    {
        width: 940,
        order: ['security', 'participants-pane']
    },
    {
        width: 840,
        order: ['security', 'participants-pane']
    },
    {
        width: 740,
        order: ['security']
    },
    {
        width: 450,
        order: []
    },
    {
        width: 400,
        order: []
    }
];
/**
 * Main toolbar buttons priority used to determine which button should be picked to fill empty spaces for disabled
 * buttons.
 */
export const MAIN_TOOLBAR_BUTTONS_PRIORITY = [
    'microphone',
    'camera',
    'desktop',
    'chat',
    'raisehand',
    'reactions',
    'participants-pane',
    'sortparticipants',
    // 'tileview',
    'invite',
    'toggle-camera',
    'videoquality',
    'sipcall',
    // 'fullscreen',
    'security',
    'closedcaptions',
    'savecaption',
    'recording',
    'livestreaming',
    'linktosalesforce',
    // 'sharedvideo',
    // 'shareaudio',
    'noisesuppression',
    'roomcascade',
    'whiteboard',
    'etherpad',
    'select-background',
    'stats',
    'shortcuts',
    'settings',
    // 'profile',
    // 'embedmeeting',
    'feedback',
    'download',
    'help'
];
export const TOOLBAR_TIMEOUT = 4000;
export const DRAWER_MAX_HEIGHT = '80dvh - 64px';
// Around 300 to be displayed above components like chat
export const ZINDEX_DIALOG_PORTAL = 302;
/**
 * Color for spinner displayed in the toolbar.
 */
export const SPINNER_COLOR = '#929292';
/**
 * The list of all possible UI buttons.
 *
 * @protected
 * @type Array<string>
 */
export const TOOLBAR_BUTTONS = [
    'camera',
    'chat',
    'closedcaptions',
    'savecaption',
    'desktop',
    'download',
    // 'embedmeeting',
    'etherpad',
    'feedback',
    'filmstrip',
    'sortparticipants',
    // 'fullscreen',
    'hangup',
    'help',
    'highlight',
    'invite',
    'linktosalesforce',
    'livestreaming',
    'microphone',
    'mute-everyone',
    'mute-video-everyone',
    'participants-pane',
    // 'profile',
    'raisehand',
    'recording',
    'security',
    'select-background',
    // 'shareaudio',
    'noisesuppression',
    // 'sharedvideo',
    'shortcuts',
    'settings',
    'stats',
    // 'tileview',
    'toggle-camera',
    'videoquality',
    'sipcall',
    'roomcascade',
    'whiteboard',
];
/**
 * The toolbar buttons to show when in visitors mode.
 */
export const VISITORS_MODE_BUTTONS = [
    'chat',
    'hangup',
    'raisehand',
    'settings',
    // 'tileview',
    // 'fullscreen',
    'stats',
    'videoquality'
];
/**
 * Custom icon toolbox button
 */
export const CUSTOM_ICON_BUTTONS = ['tileview', 'fullscreen'];
/**
 * Danh sách button ở dạng beta
 */
export const BETA_BUTTONS = ['closedcaptions'];
/**
 * Số lượng buttons cho màn prejoin
 */
export const LENGHT_BUTTONS_PREJOIN = 4;
export const TOOLBAR_HEIGHT = 88;
export const HEADER_HEAIGHT = 60;
